export const DashboardEDD = {
  title: 'Pedidos EDD'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardEDD.js